export enum LoadStates {
  INIT = -1,
  LOADDMS = 0,
  LOADUSER = 1,
  LOADMODULES = 2,
  LOADRECIPES = 3,
  LOADLASTRECIPE = 4,
  FINISHED = 5
}
